import axios from "axios";
import { baseURL } from "./Api";
import Cookie from 'cookie-universal';

const cookie = Cookie();

export const Axios = axios.create( {
    baseURL: baseURL,
} );

// يقرأ التوكن من الكوكي مع كل طلب على حدة، بدل ما ياخده مرة واحدة وقت تحميل التطبيق
Axios.interceptors.request.use( ( config ) =>
{
    const token = cookie.get( 'ecommerce' );
    if ( token )
    {
        config.headers.Authorization = `Bearer ${ token }`;
    }
    return config;
} );
